// extracted by mini-css-extract-plugin
export default {"steps":"styles_steps__-GRvk"};